import service from '../utils/request'
import { isAdminMode } from '@/utils/auth'

const url = webConfig.api.robot

// 话术详情。Admin token 使用独立的后台接口，但响应结构与普通接口一致。
export const getAdminSceneDetailA = params =>
  service.get(`${url}/admin/api/task/scene/admin/getOne`, { params })

export const getSceneDetailA = params =>
  isAdminMode()
    ? getAdminSceneDetailA(params)
    : service.get(`${url}/scene/one`, { params })

// 获取历史话术详情
export const getHistorySceneDetailA = params => service.get(`${url}/api/scene/release/one`, { params })

// 保存话术
export const editSceneA = params => service.post(`${url}/scene/edit`, params)

// 话术发布记录（历史版本列表，旧）
export const issueSceneListA = params => service.get(`${url}/scene/release`, { params })

/** 按场景查询近期发布记录 JSON 列表（约 5 条） */
export const getSceneReleaseJsonBySceneIdA = params =>
  service.get(`${url}/api/task/scene/get/scene/json/release`, { params })

/** 按发布记录回滚话术（服务端同步当前话术至该版本） */
export const sceneReleaseRollbackA = data => service.post(`${url}/api/task/scene/release/rollback`, data)

// 发布话术
export const publishSceneA = params => service.post(`${url}/scene/publish`, params)

// 获取系统意图库
export const getSystemIntentA = data => service.post(`${url}/api/ai-intent/api/v1/intent/industry/amount/get`, data)

// 等级列表（意向等级）
export const getGradeListA = params => service.get(`${url}/scene/grade/all`, { params })

// 上传语音
export const uploadA = `${url}/upload`

/** 获取通用上传凭证（与 robot-web task/record 号码文件上传一致，七牛等） */
export const getUploadTokenA = params => service.get(`${url}/upload/token`, { params: params || {} })

// 录音token
export const getRecorderTokenA = params => service.get(`${url}/scene/recorder/token`, { params })

// tts
export const getTtsListA = () => service.get(`${url}/dictionary/tts`)

// 语音识别引擎
export const getSpeechRecognitionEngineA = () => service.get(`${url}/api/user-center/speech/recognition/get`)

// 公司信息
export const getCompanyInfoA = () => service.get(`${url}/company/info`)

// 智能表单提示
export const aiFormTipsA = params => service.post(`${url}/api/crm/intention/modification/query/judgment`, params)

// 增加话术引用意图库
export const addSceneIntentA = params => service.post(`${url}/api/ai-intent/api/v1/intent/relation/scene/add`, params)

// 删除话术引用意图库
export const deleteSceneIntentA = params => service.post(`${url}/api/ai-intent/api/v1/intent/relation/scene/close`, params)

// 获取开场白绑定的任务
export const getPrologureTaskA = params => service.post(`${url}/api/task/get/scene/prologure/task/quote`, params)

// 保存场景随访配置（包括评级原则 / 意向标签）
export const editSceneFollowupA = params => service.post(`${url}/api/task/scene/edit/followup`, params)

/** LLM 克隆音色（上传完成后调用）；第三参为 copyvoice 路径，默认 G1 */
export const sceneLlmCopyVoiceA = (data, config, copyVoicePath) => {
  const path = String(copyVoicePath != null ? copyVoicePath : '').trim() || '/api/task/scene/llm/copyvoice'
  return service.post(`${url}${path}`, data, config)
}

/** 话术绑定鲸吞加微任务 */
export const bindWechatFlowTaskA = (data) =>
  service.post(`${url}/api/voice-net/wechat/flow/task`, data, { autoMsg: false })

/** 声网预热：保存话术时同步当前话术 ID 与 LLM Pro 节点话术 ID */
export const saveShengwangWarmupConfigA = (data) =>
  service.post(`${url}/api/voice-net/shengwang/warmup/config`, data, { autoMsg: false })

/**
 * 获取用户技能列表
 */
export const getUserSkillListA = () => service.post(`${url}/api/extension/userskill/list`)

// 公司配置信息
export const getCompanyConfigA = () => service.get(`${url}/api/user-center/customization/frontend/company/get`);

// 代理商权限配置信息
export const getAgentCompanyConfigA = () => service.get(`${url}/api/user-center/customization/frontend/agent/company/get`);

// 获取接收接口地址
export const getReceiveApiUrlA = () => service.get(`${url}/flow_event/url`);

// 节点评测接口
export const nodeAssessmentA = params => service.post(`${url}/api/openai/node/assessment`, params);

// 报告列表接口
export const nodeAssessmentReportA = params => service.post(`${url}/api/openai/node/assessment/report`, params);

// 报告跟进接口
export const nodeAssessmentFollowUpA = params => service.post(`${url}/api/openai/node/assessment/followup`, params);

// 短信通道列表
export const getSmsConfigCompanyChannelListA = () =>
  service.get(`${url}/api/sms-access/sms/config/company/channel/list`);
// 获取所有话术
export const getAllScenesA = params => service.get(`${url}/api/task/scene/get/llm/all`, { params });

// CRM 自定义表单：新增
export const addCrmFormA = data => service.post(`${url}/api/crm/form/add`, data)

// CRM 自定义表单：更新
export const updateCrmFormA = data => service.post(`${url}/api/crm/form/update`, data)

// CRM 自定义表单：详情（更新时用于保留推送等已有配置）
export const getCrmFormA = params =>
  service.get(`${url}/api/crm/form/get`, { params, autoMsg: false })

// CRM 自定义表单：分页列表（按名称查重）
export const getCrmFormListPageA = data =>
  service.post(`${url}/api/crm/form/list/page`, data, { autoMsg: false })

// 话术绑定自定义表单：新增绑定
export const addCrmFormSceneA = data =>
  service.post(`${url}/api/crm/form/scene/add`, data, { autoMsg: false })

// 话术绑定自定义表单：更新绑定
export const updateCrmFormSceneA = data =>
  service.post(`${url}/api/crm/form/scene/update`, data, { autoMsg: false })

// 话术绑定自定义表单：查询绑定关系
export const getCrmFormSceneListA = params =>
  service.get(`${url}/api/crm/form/scene/list`, { params, autoMsg: false })

// 话术命中统计（默认近 30 分钟）
export const getSceneHitStatA = params =>
  service.post(`${url}/api/openai/scene/hit/stat`, params, { autoMsg: false });

// 知识库命中统计
export const getKnowledgeHitStatA = params =>
  service.post(`${url}/api/openai/knowledge/hit/stat`, params, { autoMsg: false });
